import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    eventTrack = new Subject<{
        category: string;
        action: string;
        label: string;
        type?: string;
        value?: number;
    }>();
    ecommerceEventTrack = new Subject<{ ecommerce: any }>();

    constructor() {
        this.eventTrack.subscribe(
            ({ category, action, label, type, value }) => {
                (window as any).dataLayer = (window as any).dataLayer || [];
                (window as any).dataLayer.push({
                    event: 'Event',
                    category,
                    action,
                    label,
                    ...(type && { type }),
                    ...(value !== undefined && { value }),
                });
            }
        );

        this.ecommerceEventTrack.subscribe(({ ecommerce }) => {
            (window as any).dataLayer = (window as any).dataLayer || [];
            (window as any).dataLayer.push({ event: 'ecommerce', ecommerce });
        });
    }
}
